export default {
  login: {
    title: 'Sign in to FlowRent',
    welcome: 'Welcome',
    subtitle: 'Enter your credentials to access your account',
    email: 'Email',
    email_placeholder: 'you@example.com',
    password: 'Password',
    password_placeholder: 'Enter your password',
    toggle_password_visibility: 'Show or hide password',
    submit: 'Sign In',
    forgot_password: 'Forgot password?',
    privacy_policy: 'Privacy Policy',
    signup_link: 'Sign up',
    // EP-150 (App Review 5.1.1v): the banner shown after an account/login
    // deletion request, carried here via router state.
    deletion_notice: {
      account: 'This account will be erased after {{date}}. Sign in by then to restore it.',
      user: 'Your login will be erased after {{date}}. Sign in by then to restore it.',
    },
    // The panel shown instead of the ordinary wrong-password message when
    // /oauth/token answers pending_deletion.
    pending_deletion: {
      account_message: 'This account was deleted and will be erased after {{date}}.',
      user_message: 'Your login was deleted and will be erased after {{date}}.',
      restore_button: 'Restore',
      owner_only: 'Only an owner can restore this account.',
    },
    brand: {
      headline: 'Manage your rental property, all in one place',
      subline:
        'Everything from lease agreements and billing to payment tracking, plus tenant messaging over LINE.',
      features: {
        billing: 'Issue invoices and collect payments online',
        lease: 'Create digital lease agreements',
        reports: 'Full income and expense reports',
      },
      stats: {
        revenue_label: 'Revenue (this month)',
        units_label: 'Units',
        occupancy_label: 'Occupancy',
      },
    },
  },

  signup: {
    title: 'Sign up for FlowRent',
    subtitle: 'Create your account',
    account_name: 'Business or property name',
    owner_first_name: 'First name',
    owner_last_name: 'Last name',
    email: 'Email',
    email_placeholder: 'you@example.com',
    phone: 'Phone',
    phone_placeholder: '0812345678',
    address: 'Address',
    invitation_code: 'Invitation code',
    invitation_code_hint: 'The 6-character code from the FlowRent team',
    no_code: 'No invitation code? Contact us',
    // EP-160 T160-201w (S9, D4): the onboarding grant, ticked by default.
    support_onboarding: {
      label: 'Let the FlowRent team help set up the account during the first 30 days',
      detail: '(sees buildings, rooms and prices; sees tenant details partly masked; you can withdraw this at any time)',
    },

    // EP-160 (section 2.7, AC-10): the required terms box.
    terms: {
      accept: 'I accept the FlowRent Terms of Service and Privacy Policy',
      terms_link: 'Terms of Service',
      privacy_link: 'Privacy Policy',
    },
    submit: 'Sign up',
    have_account: 'Already have an account? Sign in',
    success: {
      title: 'Check your email',
      body: 'We sent a link to set your password to {{email}}.',
      expiry: 'The link is valid for {{hours}} hours',
      retry: 'If the link expires, use Forgot password with the same email.',
      sign_in: 'Go to sign in',
    },
    errors: {
      invitation_code_invalid: 'That invitation code is not valid or has already been used.',
      email_taken: 'This email already belongs to a FlowRent user. Sign in instead.',
      validation_failed: 'Please check the highlighted fields.',
      rate_limited: 'Too many sign-up attempts. Please try again later.',
      generic: 'Sign-up failed. Please try again.',
    },
    validation: {
      account_name_required: 'Enter your business or property name.',
      first_name_required: 'Enter your first name.',
      last_name_required: 'Enter your last name.',
      email_invalid: 'Enter a valid email address.',
      phone_invalid: 'Enter a valid phone number.',
      address_required: 'Enter your address.',
      account_name_too_long: 'Use at most {{max}} characters.',
      first_name_too_long: 'Use at most {{max}} characters.',
      last_name_too_long: 'Use at most {{max}} characters.',
      address_too_long: 'Use at most {{max}} characters.',
      code_length: 'The invitation code is 6 characters.',
      terms_required: 'Accept the Terms of Service and Privacy Policy to sign up.',
    },
  },

  forgot_password: {
    title: 'Forgot Password',
    subtitle: 'Enter your email to receive a password reset link',
    email: 'Email',
    email_placeholder: 'you@example.com',
    submit: 'Send Reset Link',
    back_to_login: 'Back to login',
    success_message: 'If an account exists with this email, you will receive a password reset link.',
  },

  reset_password: {
    title: 'Reset Password',
    subtitle: 'Enter your new password',
    password: 'New Password',
    password_placeholder: 'Enter new password',
    confirm_password: 'Confirm Password',
    confirm_password_placeholder: 'Confirm your password',
    submit: 'Reset Password',
    success_message: 'Your password has been reset successfully.',
    invalid_token: 'Invalid or expired reset token.',
    passwords_not_match: 'Passwords do not match',
  },

  // EP-160 (section 2.7, D5): the owner's one-time banner when the terms
  // change. A banner, never a gate.
  terms_banner: {
    message: 'FlowRent has updated its Terms of Service',
    read: 'Read the terms',
    accept: 'Accept',
    dismiss: 'Dismiss',
    accept_failed: 'Could not record your acceptance. Please try again.',
  },

  errors: {
    invalid_credentials: 'Invalid email or password',
    account_locked: 'Your account has been locked',
    session_expired: 'Your session has expired. Please sign in again.',
    // EP-150: restoring an account/login pending deletion.
    owner_required: 'Only an owner can restore this account.',
    not_pending_deletion: 'This account is not scheduled for deletion.',
  },
}
